import { emailRegEx } from 'ecs-react-components/dist/index.es';

export default {
  recipient: {
    required: true,
    validateOnBlur: false,
    promise: (fieldName, fieldValue) => (
      new Promise((resolve, reject) => {
        if (fieldValue && !emailRegEx.test(fieldValue)) {
          reject();
        } else {
          resolve();
        }
      })
    ),
  },
  sender: {
    required: true,
    validateOnBlur: false,
    promise: (fieldName, fieldValue) => (
      new Promise((resolve, reject) => {
        if (fieldValue && !emailRegEx.test(fieldValue)) {
          reject();
        } else {
          resolve();
        }
      })
    ),
  },
  emailBody: {
    maxLength: 2000,
    validateOnBlur: false,
  },
};
